import React from 'react';
import { connect } from 'react-redux';
import BaseComponent from '../../baseClasses/BaseComponent';

import CompaniesIcon from './CompaniesIcon';
import DirectoryIcon from './DirectoryIcon';
import DocumentsIcon from './DocumentsIcon';
import NotificationsIcon from './NotificationsIcon';
import ProjectsIcon from './ProjectsIcon';
import ProjectTypesIcon from './ProjectTypesIcon';
import DashboardIcon from './DashboardIcon';
import TasksIcon from './TasksIcon';
import LocationsIcon from './LocationsIcon';
import OfflineIconSingle from './OfflineIconSingle';
import OfflineIconDouble from './OfflineIconDouble';

class Iconoclast extends BaseComponent {

  shouldComponentUpdate(nextProps) {
    if(this.props.currentCompany && nextProps.currentCompany && this.props.currentCompany.id != nextProps.currentCompany.id){
      return true;
    }
    if (
      (nextProps.selected && this.props.selected) ||
      this.props.color ||
      nextProps.color) {
      return false;
    } else {
      return true;
    }
  }

  handleMouseEnter(){
    this.setState({ hover: true });
  }
  handleMouseLeave(){
    this.setState({ hover: false });
  }

  render() {
    let { 
      selected, // used for header icons to show what page is selected
      color, // if selected it will skip over changing the icon between black and company color
      type, // determines what icon is displayed
      // width,  these are optional that will be passed down to the child components
      // height
    } = this.props;
    let iconColor = '#000000';
    if(color){
      iconColor = color;
    }
    else{
      let accentColor = this.props.currentCompany &&
        this.props.currentCompany.accent_color ?
        this.props.currentCompany.accent_color : 
        '#CD030A';
  
      if(this.state.hover){
        iconColor = accentColor;
      }
      if(selected){
        iconColor = accentColor;
      }
    }
    let icon;
    switch(type){
    case 'companies':
      icon = <CompaniesIcon {...this.props} iconColor={iconColor}/>;
      break;
    case 'directory':
      icon = <DirectoryIcon {...this.props} iconColor={iconColor}/>;
      break;
    case 'documents':
      icon = <DocumentsIcon {...this.props} iconColor={iconColor}/>;
      break;
    case 'locations':
      icon = <LocationsIcon {...this.props} iconColor={iconColor}/>;
      break;
    case 'notifications':
      icon = <NotificationsIcon {...this.props} iconColor={iconColor}/>;
      break;
    case 'projects':
      icon = <ProjectsIcon {...this.props} iconColor={iconColor}/>;
      break;
    case 'project-types':
      icon = <ProjectTypesIcon {...this.props} iconColor={iconColor}/>;
      break;
    case 'dashboard':
      icon = <DashboardIcon {...this.props} iconColor={iconColor}/>;  
      break;
    case 'tasks':
      icon = <TasksIcon {...this.props} iconColor={iconColor}/>;
      break;
    case 'offline-single':
      icon = <OfflineIconSingle {...this.props} iconColor={iconColor}/>;
      break;
    case 'offline-double':
      icon = <OfflineIconDouble {...this.props} iconColor={iconColor}/>;
      break;
    default:
      break;
    }
    
    return (
        <div onMouseEnter={this.handleMouseEnter} onMouseLeave={this.handleMouseLeave}>
          {icon}
        </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  let company = state.new_companies.currentCompany;
  if (company && state.new_companies[company.id]) {
    company = state.new_companies[company.id];
  }
  return {
    currentCompany: company,
  };
};

export default connect(mapStateToProps)(Iconoclast);



// WEBPACK FOOTER //
// ./src/components/Iconoclast/index.js